export enum WidgetCommandEnum {
	RELOAD = '/reload'
}

export const WidgetCommmandFromIndex: {[id: number]: WidgetCommandEnum} = {
	0: WidgetCommandEnum.RELOAD
};
export default WidgetCommandEnum;